import {
  ConversationReference,
  ConversationReferenceFilterInput,
  useConversationReferenceAutocompleteQuery,
} from '~/types/api.graphql';

const MENTION_AUTOCOMPLETE_LIMIT = 10;

interface UseConversationReferenceMentionsOptions {
  query: string | null;
  filter?: ConversationReferenceFilterInput;
}

export const useConversationReferenceMentions = ({ query, filter }: UseConversationReferenceMentionsOptions) => {
  const skip = query === null || query.trim().length < 2;

  const { data, loading } = useConversationReferenceAutocompleteQuery({
    variables: {
      searchQuery: query ?? '',
      first: MENTION_AUTOCOMPLETE_LIMIT,
      filter,
    },
    skip,
    fetchPolicy: 'cache-and-network',
  });

  const results: ConversationReference[] = skip ? [] : data?.conversationReferenceAutocomplete?.nodes ?? [];

  return { results, loading: loading && !skip };
};
